import { connect } from 'react-redux';
import MusicSingleVideosSlider from '../components/MusicSingleVideosSliderComponent';

const mapStateToProps = (state) => ({
    isMedium: state.breakpointReducer.isMedium,
    isLarge: state.breakpointReducer.isLarge,
    isExtraLarge: state.breakpointReducer.isExtraLarge,
});

// passing an empty object for mapDispatchToProps to avoid dispatch being passed on and causing prop-types-exact to complain
export default connect(mapStateToProps, {})(MusicSingleVideosSlider);
